import { Uuid } from "@/domains/global/identifiers";
import { UuidNamespace } from "@/modules/uuid/constants";
import { combineUuidsUsingNamespace } from "@/modules/uuid/sync-models/combineUuidsUsingNamespace";

/**
 * Resolves the UUID for the default calendar event template sync model.
 * This creates a deterministic UUID based on the space account ID.
 */
export const resolveDefaultCalendarEventTemplateSyncModelUuid = ({
  spaceAccountId,
}: {
  spaceAccountId: Uuid;
}): Uuid => {
  return combineUuidsUsingNamespace({
    namespace: UuidNamespace.DefaultCalendarEventTemplateNamespace,
    uuids: [spaceAccountId],
  });
};
